export const ALLOWED_IFRAME_URLS = {
  DOCUMENSO_LOCAL_BASE_URL: 'http://localhost:3000',
  DOCUMENSO_DEV_BASE_URL: 'https://signature.business-kitz.com',
  DOCUMENSO_TEST_BASE_URL: 'https://signature.businesskits.co.nz',
  DOCUMENSO_PROD_BASE_URL: 'https://signature.businesskitz.com',
  LOCALHOST: 'http://localhost',
};

export const DOCUMENSO_BASE_URL = (() => {
  const baseUrl = (() => {
    switch (import.meta.env.VITE_ENV_TYPE) {
      case 'LOCAL':
        return import.meta.env.DOCUMENSO_BASE_URL || ALLOWED_IFRAME_URLS.DOCUMENSO_LOCAL_BASE_URL;
      case 'DEV':
        return ALLOWED_IFRAME_URLS.DOCUMENSO_DEV_BASE_URL;
      case 'TEST':
        return ALLOWED_IFRAME_URLS.DOCUMENSO_TEST_BASE_URL;
      case 'PROD':
        return ALLOWED_IFRAME_URLS.DOCUMENSO_PROD_BASE_URL;
      default:
        return null;
    }
  })();

  return new URL(baseUrl);
})();

export const DOCUMENSO_LOGIN_URL = (() => {
  const url = new URL('signin', DOCUMENSO_BASE_URL);
  url.searchParams.append('auto_login', 'oidc');
  return url;
})();

export const DOCUMENSO_DOCUMENTS_URL = (() => {
  const url = new URL('documents', DOCUMENSO_BASE_URL);
  return url;
})();

export const DOCUMENSO_SIGNING_URL = (() => {
  const url = new URL('signing', DOCUMENSO_BASE_URL);
  return url;
})();

export const document_sign_url = (documentId: string, view?: boolean) => {
  const url = `documents/${documentId}${view ? '' : '/edit'}`;
  return url;
};
